module.exports = __webpack_public_path__ + "static/img/slider-researchers.4b87c34.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/color-theme/img/slider/slider-researchers.jpg
// module id = yf6w
// module chunks = 1